import { DEFAULT_CANCEL_REASON_ID, OTHER_CANCEL_REASON_ID } from '../../../constants';

const shuffleArray = (arr) =>
  arr
    .map((a) => [Math.random(), a])
    .sort((a, b) => a[0] - b[0])
    .map((a) => a[1]);

const initialCancelReason = { cancelReasonId: DEFAULT_CANCEL_REASON_ID };
const buildCancelReasonList = (baseCancelReasons) => {
  const otherCancelReason = baseCancelReasons.find((reason) => reason.cancelReasonId === OTHER_CANCEL_REASON_ID);
  const reasons = baseCancelReasons.filter((reason) => reason !== otherCancelReason);
  const shuffledReasons = shuffleArray(reasons);

  const list = [initialCancelReason, ...shuffledReasons];
  if (otherCancelReason) {
    list.push(otherCancelReason);
  }

  return list;
};

export default buildCancelReasonList;
